<template>
  <floating-window name="canvas" left="150" top="100" defaultVisible="true">
    <div class="canvas-ui">
      <div>
        <el-switch
          v-model        ="toggel"
          inactive-color ="#ff4949"
          active-text    ="enable"
          inactive-text  ="disable"
        /><br>
        <el-button type="danger" @click="clear">clear</el-button>
      </div>
      <pen-property />
    </div>
    <div>
      layer-select
      <div style="background-color: gray; width: 100%; height: 100px">
        layer1
        layer2
      </div>
    </div>
  </floating-window>
</template>

<script>
import penProperty from './penProperty'

export default {
  name: 'CanvasUi',
  data () {
    return {
      toggel: true
    }
  },
  computed: {
  },
  methods: {
    toggle () {
      this.$eventHub.$emit('toggle-click')
    },
    clear () {
      this.$eventHub.$emit('canvas-clear')
    }
  },
  components: {
    penProperty
  }
}
</script>

<style scoped>
.canvas-ui {
  height      : auto;
  width       : 200px;
  user-select : none;
  padding     : 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/canvas/controller/index.vue